import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, ValidationOptions, registerDecorator } from 'class-validator';
import TenantsStore from '@/store/modules/TenantsStoreModule';
import { TenantsStoreModule, TenantDetailsStoreModule } from '@/store';
import TenantDetailsStore from '@/store/modules/TenantDetailsStoreModule';

@ValidatorConstraint()
export class TenantDetailsValidatorIsPropertyUniqueContraint implements ValidatorConstraintInterface {

    tenants$: TenantsStore = TenantsStoreModule;
    tenantDetails$: TenantDetailsStore = TenantDetailsStoreModule;

    validate(value: string, validationArguments: ValidationArguments) {
        return this.tenants$.tenants.findIndex((tenant: any) =>
            // Don't check against the current tenant
            (value !== (this.tenantDetails$.tenantDetails as any)[validationArguments.property]) &&
            // Check if the value is set on another tenant
            tenant[validationArguments.property] === value) === -1;
    }
}

export function TenantDetailsValidatorIsPropertyUnique(validationOptions?: ValidationOptions) {
    return (object: any, propertyName: string) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [],
            validator: TenantDetailsValidatorIsPropertyUniqueContraint,
        });
    };
}
